import type { RestaurantRole } from '@/bindings/RestaurantRole'
import { parsePageSearch } from '@/lib/page-search'
import { isRole } from '@/lib/roles'

export interface AccountsSearch {
  page: number
  /** Absent or unknown → the page falls back to the actor's next-lower role. */
  role?: RestaurantRole
}

export function parseAccountsSearch(search: Record<string, unknown>): AccountsSearch {
  const { page } = parsePageSearch(search)
  return isRole(search.role) ? { page, role: search.role } : { page }
}
